module.exports = "https://r.nearpod.com/assets/media/image/personalized_news_icon-64dadd19d7f1f6ef996f4bbe524b9204.svg";